import { PublicServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { put, takeEvery } from 'redux-saga/effects';

import { fromDto } from '../../../models/adapters/PlaceActivationAdapter';
import { activatePlaceFetched, activatePlaceFetchFailed, fetchActivatePlace, FetchActivatePlaceActionType } from '../../actions/registration/activatePlace';
import getPublicResponse from '../getPublicResponse';

function* fetchActivatePlaceSaga({ payload }: FetchActivatePlaceActionType) {
  const timestamp = moment();
  const { token } = payload;
  const response = yield getPublicResponse(PublicServerPlaceEvent.getPlaceActivation, {
    token,
  });
  const { placeActivationDto, error } = response;
  if (error) {
    const action = activatePlaceFetchFailed({ timestamp });
    yield put(action);
  } else {
    const action = activatePlaceFetched({ placeActivationData: fromDto(placeActivationDto), timestamp });
    yield put(action);
  }
}

export default function* watchFetchActivatePlaceSaga() {
  yield takeEvery(fetchActivatePlace, fetchActivatePlaceSaga);
}
